import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
    createPartnerService,
    updatePartnerPreferences,
    deletePartner,
    getPartnerPreferences,
    listPartners,
    officeList,
    listProvider,
    fetchPartnerData,
    listChildPartners,
    listPartnersByType,
    listStockPointsByTenant,
    listOfficeByPartner,
    allStockPointTenant,
    changePasswordPartner,
    updatePartnerService,
    getPartnerListLite,
    updatePartnerPaymentPreferences,
    getPartnerPaymentPreferences,
    updatePartnerPaymentConfig,
    getPartnerPaymentConfig,
    getPartnerParentData,
    getSellerProviderConfig,
    listPartnerTypeFilter,
    listTenantPartners,
    partnerSearchByNameEmailPhone,
    getPartnerDetailsById,
    getApprovalList,
    updateApprovalRequest,
    getApprovalRequestById,
    fetchPartnerMarketSegment,
    offlinePartner,
    partnerStatusUpdate,
    getAnalyticReport,
    getBulkAnalyticReport,
    getPartnerCustomer,
    createCustomer,
    updateCustomer,
    getBulkCustomerList,
    bulkCustomerImport,
    getStockPointByProvider,
    viewAgentDetails,
    updateUser,
    updateKyc,
    walletList,
    fetchRequestDownload,
    createRequestDownload,
    updateProfile,
    getSlaReportList,
    setPartnerConfig,
    getPartnerConfig,
    getReviewList,
    replyToCustomer,
    updateApproval,
    chatList,
} from "@/services/partner";

function normalizePartnerForTable(obj: any) {
    return {
        _id: obj._id,
        userName: obj?.authentication?.userName,
        email: obj?.authentication?.email,
        phone: obj?.authentication?.phone,
        ...obj,
    };
}

@Module({
    namespaced: true,
})
export default class Partner extends VuexModule {
    // state
    partnerList = [];
    partnerListMeta = {};
    allstockpointList = [];
    stockpointList = [];
    editPartner = null;
    partnerPreferences = {};
    partnerListLite = [];
    childPartnerList = [];
    getPartnerPaymentConfigSetter = {};
    getPartnerPaymentPreferencesSetter = {};
    getSellerProviderConfig = {};
    getMyParentSetter = {};
    partnerDetailsById = {};
    approvalList = [];
    graphData = {};
    customerDSOList = [];
    numberOfDSO = {};
    UsdValueOfTickets = [];
    CustomerUsdValueOfTickets = [];
    CustomerNoOfNonProdHoursByTech = [];
    NoOfNonProdHoursByTech = [];
    doughnutChartData = {};
    salesTechData = {};
    salesRegionData = {};
    numberOfMarginByTech = {};
    numberOfTickets = {};
    sameTimePreviousYear = {};
    customerSameTimePreviousYyear = {};
    customerNumberOfJobsByTicketSize = {};
    customerListData = {};
    numberOfJobsByTicketSize = {};
    hoursTechStraightOvertimeData = {};
    dailyRegistrationGraphData = {};
    top10PerformerData = {};
    marketWisePerformers = {};
    orderByTypeGraphData = {};
    partnerCustomerList = [];
    customerbulkreportlist = [];
    agentDetails = [];
    walletData = [];
    chartData = {};
    request = [];
    providers = [];
    extendedData = {};
    slaReport = {
        data: [],
        totalItems: 0,
    };
    partnerConfig = {};
    reviewList = [];
    replyCustomer = [];
    chatListMsg = [];
    // actions
    @Action
    public async fetchFraudManagementData(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchFraudAlertData(payload) {
        try {
            const res = await getBulkAnalyticReport(payload);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchRiskData(payload) {
        try {
            const res = await getBulkAnalyticReport(payload);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async createRequestDownload(payload) {
        try {
            const data = await createRequestDownload(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchRequest(payload) {
        try {
            const data = await fetchRequestDownload(payload);
            this.context.commit("setRequest", data.data);
            return data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchWalletList(payload) {
        try {
            const response = await walletList(payload);
            this.context.commit("setWalletList", response.data.response);
            return response;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateKyc(data) {
        try {
            const res = await updateKyc(data, data.payload);
            return res.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateUser(data) {
        try {
            const res = await updateUser(data._id, data.payload);
            return res.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async updateprofileAction(data) {
        try {
            const res = await updateProfile(data.id, data.data);
            return res.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async viewAgentDetails(payload) {
        this.context.commit("setAgentDetails", {}); // reset
        try {
            const res = await viewAgentDetails(payload.id);
            this.context.commit("setAgentDetails", res.data.response);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async bulkCustomerImport(payload) {
        try {
            const data = await bulkCustomerImport(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getBulkCustomerList(payload) {
        try {
            const response = await getBulkCustomerList(payload);
            this.context.commit("setBulkCustomerList", response.data.data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async createCustomer(payload) {
        try {
            const data = await createCustomer(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateCustomer(data) {
        try {
            const res = await updateCustomer(data._id, data.payload);
            return res.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchPartnerCustomerList(payload) {
        try {
            const data = await getPartnerCustomer(payload);
            this.context.commit("setPartnerCustomerList", data.data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getSellerProviderConfigAction(payload) {
        try {
            const data = await getSellerProviderConfig(payload);
            this.context.commit("getSellerProviderConfigMutation", data.data);
            return data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async setPartnerConfigAction(payload) {
        try {
            const data = await setPartnerConfig(payload);

            return data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getPartnerConfigAction(payload) {
        try {
            const data = await getPartnerConfig(payload);
            this.context.commit("setPartnerConfigData", data.data.response);
            return data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getReviewListAction(payload) {
        try {
            const data = await getReviewList(payload);
            this.context.commit("setReviewData", data.data.data);
            return data.data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async handleReplyToCustomer(payload) {
        try {
            const data = await replyToCustomer(payload);
            this.context.commit("setReplyToCustomer", data);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateApprovalAction(payload) {
        try {
            const data = await updateApproval(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchChatList() {
        try {
            const data = await chatList();
            this.context.commit("setChatList", data.data);
            return data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchPartnerDetailsById(payload) {
        try {
            const data = await getPartnerDetailsById(payload);
            this.context.commit("setPartnerDetailsById", data.response);
            let extendedData = {};
            if (data.response.extendedAttributes) {
                for (const [key, value] of Object.entries(
                    data.response.extendedAttributes,
                )) {
                    if (key == "firstLogin") continue;
                    if (typeof value == "object") continue;
                    extendedData[key] = value;
                }
            }
            this.context.commit("setExtendedData", extendedData);

            return data.response;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async listPartnerTypeFilterAction(payload) {
        try {
            const data = await listPartnerTypeFilter(payload);
            this.context.commit("setPartnerList", data.response);
            return data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async listPartnerSearchByNameEmailPhone(payload) {
        try {
            const data = await partnerSearchByNameEmailPhone(payload);
            this.context.commit("setPartnerList", data.response);
            return data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchPartnersList(payload) {
        try {
            const data = await listPartners(payload);
            this.context.commit("setPartnerList", data.response);
            this.context.commit("setPartnerListMeta", data.meta);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchTenantPartnersList(payload) {
        try {
            const data = await listTenantPartners(payload);
            this.context.commit("setPartnerList", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async officeList(payload) {
        try {
            const data = await officeList(payload && payload.type || "");
            const normalized = Array.isArray(data.response)
                ? data.response.map(normalizePartnerForTable)
                : [];
            this.context.commit("setPartnerList", normalized);
            this.context.commit("setPartnerListMeta", data.meta);
            return data;
        } catch (error) {
            throw error;
        }
    }
    // @Action
    // public async officeList(payload) {
    //   try {
    //     const data = await officeList();
    //     this.context.commit("setPartnerList", data.response);
    //     this.context.commit("setPartnerListMeta", data.meta);
    //     return data;
    //   } catch (error) {
    //     throw error;
    //   }
    // }

    @Action
    public async fetchProviderList() {
        try {
            const data = await listProvider();
            this.context.commit("setproviderList", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchPartnerById(payload) {
        try {
            const data = await fetchPartnerData(payload);
            this.context.commit("setEditedPartnerData", data.response);
            let extendedData = {};
            const extendedAttrs = data.response.extendedAttributes;
            if (extendedAttrs && typeof extendedAttrs === "object") {
                for (const [key, value] of Object.entries(extendedAttrs)) {
                    if (key == "firstLogin") continue;
                    if (typeof value == "object") continue;
                    extendedData[key] = value;
                }
            }
            this.context.commit("setExtendedData", extendedData);

            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchOfficerById(payload) {
        try {
            const data = await fetchPartnerData(payload);
            this.context.commit("setEditedPartnerData", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getMyParentAction(payload) {
        try {
            const data = await getPartnerParentData(payload);
            this.context.commit("setMyParentMutation", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getPartnerPaymentConfigAction(payload) {
        try {
            const data = await getPartnerPaymentConfig(payload);
            this.context.commit("getPartnerPaymentConfigMutation", data.data);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updatePartnerPaymentConfigAction(payload) {
        try {
            const data = await updatePartnerPaymentConfig(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updatePartnerPaymentPreferencesAction(payload) {
        try {
            const data = await updatePartnerPaymentPreferences(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getPartnerPaymentPreferencesAction(payload) {
        try {
            const data = await getPartnerPaymentPreferences(payload);
            this.context.commit(
                "getPartnerPaymentPreferencesMutation",
                data.response,
            );
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchChildPartnersList(parentId) {
        try {
            const data = await listChildPartners(parentId);
            this.context.commit("setChildPartnerList", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchPartnerListLite(payload) {
        try {
            const data = await getPartnerListLite(payload);
            this.context.commit("setPartnerListLite", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchPartnersListByType(payload) {
        try {
            const data = await listPartnersByType(payload);
            this.context.commit("setPartnerList", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchPartnerMarketSegment() {
        try {
            const data = await fetchPartnerMarketSegment({});
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updatePartner(payload) {
        try {
            const data = await updatePartnerService(payload.id, payload.data);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchAllStockPointTenant() {
        try {
            const data = await allStockPointTenant();
            this.context.commit("setAllStockPointList", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchStockpointsByTenant() {
        try {
            const data = await listStockPointsByTenant();
            this.context.commit("setStockPointList", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchStockpointByProvider(payload) {
        try {
            const data = await getStockPointByProvider(payload);
            this.context.commit("setStockPointList", data.data.response);
            return data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public editPartnerData(data) {
        this.context.commit("setEditedPartnerData", data);
    }
    @Action
    public async fetchOfficesByPartner() {
        try {
            const data = await listOfficeByPartner();
            this.context.commit("setPartnerList", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async createPartner(payload) {
        try {
            const data = await createPartnerService(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async changePasswordPartner(payload) {
        try {
            const data = await changePasswordPartner(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updatePartnerPreferences(payload) {
        try {
            const data = await updatePartnerPreferences(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getPartnerPreferences(payload) {
        try {
            const data = await getPartnerPreferences(payload);
            this.context.commit("setPartnerPreference", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async deletePartner(payload) {
        try {
            const data = await deletePartner(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getApprovalList(payload) {
        try {
            const data = await getApprovalList(payload);
            this.context.commit("setApprovalList", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateApprovalRequest(payload) {
        try {
            const data = await updateApprovalRequest(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getApprovalRequestById(payload) {
        try {
            const data = await getApprovalRequestById(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async offlinePartner(payload) {
        try {
            const data = await offlinePartner(payload.id, payload.data);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async partnerStatusUpdate(payload) {
        try {
            const data = await partnerStatusUpdate(payload.id, payload.data);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchAnalyticReport(payload) {
        try {
            if (Array.isArray(payload)) {
                const responseData = {};
                const allData = payload.map(async (x) => {
                    const res = await getAnalyticReport(x.payload);
                    responseData[x.key] = res.data.response;
                    return;
                });
                await Promise.all(allData);
                return responseData;
            }
            const data = await getAnalyticReport(payload);
            return data.data.response;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchBulkAnalyticReport(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setDailyRegistrationChart", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchTop10Performer(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setTop10Performer", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchMarketWisePerformer(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setMarketWisePerformer", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchOrderByTypeChartReport(payload) {
        try {
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setOrderByTypeChart", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchBulkChart(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setDashboardChart", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchCustomerNumberOfDSOList(payload) {
        try {
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setCustomerDSOList", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchNumberOfDSO(payload) {
        try {
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setNumberOfDSOList", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchUsdValueOfTickets(payload) {
        try {
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setUsdValueOfTickets", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchCustomerUsdValueOfTickets(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setCustomerUsdValueOfTickets", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchCustomerNoOfNonProdHoursByTech(payload) {
        try {
            const res = await getBulkAnalyticReport(payload);
            this.context.commit(
                "setCustomerNoOfNonProdHoursByTech",
                res.data.data,
            );
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchNoOfNonProdHoursByTech(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setNoOfNonProdHoursByTech", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchTopMarketData(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setTopMarketData", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchChart(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setChart", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchNumnerSalesTech(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setNumberSalesTech", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchNumnerSalesRegion(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setNumberSalesRegion", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchHoursTechStraightOvertime(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setHoursTechStraightOvertime", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchNumberOfMarginByTech(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setNumberOfMarginByTech", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchNumberOfTickets(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setNumberOfTickets", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchSameTimePreviousYear(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setSameTimePreviousYear", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchCustomerSameTimePreviousYear(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit(
                "setCustomerSameTimePreviousYyear",
                res.data.data,
            );
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchNumberOfJobsByTicketSize(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setNumberOfJobsByTicketSize", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchCustomerNumberOfJobsByTicketSize(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit(
                "setCustomerNumberOfJobsByTicketSize",
                res.data.data,
            );
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchSlaReportList(payload) {
        try {
            let responseData = {};
            const res = await getSlaReportList(payload);
            this.context.commit(
                "setSlaReportData",
                res.data.data["sla-report"],
            );
            return res;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchCustomerListData(payload) {
        try {
            let responseData = {};
            const res = await getBulkAnalyticReport(payload);
            this.context.commit("setCustomerListData", res.data.data);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }

    // mutations
    @Mutation
    public setRequest(data: any) {
        this.request = data;
    }

    @Mutation
    public setWalletList(data) {
        this.walletData = data;
    }

    @Mutation
    public setAgentDetails(data: any) {
        this.agentDetails = data;
    }

    @Mutation
    public setPartnerConfigData(data: any) {
        this.partnerConfig = data;
    }

    @Mutation
    public setReviewData(data: any) {
        this.reviewList = data;
    }
    @Mutation
    public setReplyToCustomer(data: any) {
        this.replyCustomer = data;
    }
    @Mutation
    public setChatList(data: any) {
        this.chatListMsg = data;
    }
    @Mutation
    public setBulkCustomerList(data) {
        this.customerbulkreportlist = data;
    }

    @Mutation
    public setPartnerCustomerList(data: any) {
        this.partnerCustomerList = data;
    }

    @Mutation
    public setDashboardChart(data: any) {
        this.graphData = data;
    }
    @Mutation
    public setCustomerDSOList(data: any) {
        this.customerDSOList = data;
    }
    @Mutation
    public setNumberOfDSOList(data: any) {
        this.numberOfDSO = data;
    }
    @Mutation
    public setUsdValueOfTickets(data: any) {
        this.UsdValueOfTickets = data;
    }
    @Mutation
    public setCustomerUsdValueOfTickets(data: any) {
        this.CustomerUsdValueOfTickets = data;
    }
    @Mutation
    public setCustomerNoOfNonProdHoursByTech(data: any) {
        this.CustomerNoOfNonProdHoursByTech = data;
    }
    @Mutation
    public setNoOfNonProdHoursByTech(data: any) {
        this.NoOfNonProdHoursByTech = data;
    }
    @Mutation
    public setTopMarketData(data: any) {
        this.doughnutChartData = data;
    }

    @Mutation
    public setDailyRegistrationChart(data: any) {
        this.dailyRegistrationGraphData = data;
    }
    @Mutation
    public setTop10Performer(data: any) {
        this.top10PerformerData = data;
    }
    @Mutation
    public setMarketWisePerformer(data: any) {
        this.marketWisePerformers = data;
    }

    @Mutation
    public setOrderByTypeChart(data: any) {
        this.orderByTypeGraphData = data;
    }

    @Mutation
    public setChart(data: any) {
        this.chartData = data;
    }

    @Mutation
    public setNumberSalesTech(data: any) {
        this.salesTechData = data;
    }
    @Mutation
    public setNumberSalesRegion(data: any) {
        this.salesRegionData = data;
    }
    @Mutation
    public setHoursTechStraightOvertime(data: any) {
        this.hoursTechStraightOvertimeData = data;
    }
    @Mutation
    public setNumberOfMarginByTech(data: any) {
        this.numberOfMarginByTech = data;
    }
    @Mutation
    public setNumberOfTickets(data: any) {
        this.numberOfTickets = data;
    }
    @Mutation
    public setSameTimePreviousYear(data: any) {
        this.sameTimePreviousYear = data;
    }
    @Mutation
    public setCustomerSameTimePreviousYyear(data: any) {
        this.customerSameTimePreviousYyear = data;
    }
    @Mutation
    public setCustomerNumberOfJobsByTicketSize(data: any) {
        this.customerNumberOfJobsByTicketSize = data;
    }
    @Mutation
    public setCustomerListData(data: any) {
        this.customerListData = data;
    }
    @Mutation
    public setNumberOfJobsByTicketSize(data: any) {
        this.numberOfJobsByTicketSize = data;
    }

    @Mutation
    public setApprovalList(data: any) {
        this.approvalList = data;
    }

    @Mutation
    public setPartnerList(data: any) {
        this.partnerList = data;
    }
    @Mutation
    public setproviderList(data: any) {
        this.providers = data;
    }

    @Mutation
    public setPartnerListMeta(data: any) {
        this.partnerListMeta = data;
    }

    @Mutation
    public getPartnerPaymentPreferencesMutation(data: any) {
        this.getPartnerPaymentPreferencesSetter = data;
    }

    @Mutation
    public setAllStockPointList(data: any) {
        this.allstockpointList = data;
    }

    @Mutation
    public getPartnerPaymentConfigMutation(data: any) {
        this.getPartnerPaymentConfigSetter = data;
    }

    @Mutation
    public setChildPartnerList(data: any) {
        this.partnerList = data;
    }

    @Mutation
    public setPartnerListLite(data: any) {
        this.partnerListLite = data;
    }

    @Mutation
    public setStockPointList(data: any) {
        this.stockpointList = data;
    }

    @Mutation
    public setEditedPartnerData(data: any) {
        this.editPartner = data;
    }
    @Mutation
    public setExtendedData(data: any) {
        this.extendedData = data;
    }
    @Mutation
    public setPartnerPreference(data: any) {
        this.partnerPreferences = data;
    }

    @Mutation
    public setMyParentMutation(data: any) {
        this.getMyParentSetter = data;
    }

    @Mutation
    public getSellerProviderConfigMutation(data: any) {
        this.getSellerProviderConfig = data;
    }

    @Mutation
    public setPartnerDetailsById(data: any) {
        this.partnerDetailsById = data;
    }

    @Mutation
    public setSlaReportData(data: any) {
        this.slaReport.data = data.result || [];
        this.slaReport.totalItems =
            data.parameters?.pagination?.totalItems * 1 || 0;
    }

    // getters

    get GetAllStockPointList() {
        return this.allstockpointList;
    }

    get GetSellerProviderConfigGatter() {
        return this.getSellerProviderConfig;
    }

    get GetPartnerList() {
        return this.partnerList;
    }

    get GetProviderList() {
        return this.providers;
    }

    get GetChildPartnerList() {
        return this.childPartnerList;
    }

    get GetPartnerLiteList() {
        return this.partnerListLite;
    }

    get GetStockPointList() {
        return this.stockpointList;
    }

    get GetPartnerData() {
        return this.editPartner;
    }
    get GetPartnerPreferences() {
        return this.partnerPreferences;
    }

    get GetPartnerPaymentConfig() {
        return this.getPartnerPaymentConfigSetter;
    }

    get getPartnerPaymentPreferencesGetter() {
        return this.getPartnerPaymentPreferencesSetter;
    }

    get getMyParentGatter() {
        return this.getMyParentSetter;
    }

    get GetPartnerDetailsById() {
        return this.partnerDetailsById;
    }
    get GetApprovalsList() {
        return this.approvalList;
    }
    get getBulkAnalyticsReport() {
        return this.graphData;
    }
    get GetCustomerDSOList() {
        return this.customerDSOList;
    }
    get GetNumberOfDSO() {
        return this.numberOfDSO;
    }
    get getUsdValueOfTickets() {
        return this.UsdValueOfTickets;
    }
    get getCustomerUsdValueOfTickets() {
        return this.CustomerUsdValueOfTickets;
    }
    get getCustomerNoOfNonProdHoursByTech() {
        return this.CustomerNoOfNonProdHoursByTech;
    }
    get getNoOfNonProdHoursByTech() {
        return this.NoOfNonProdHoursByTech;
    }
    get getTopMarketChartData() {
        return this.doughnutChartData;
    }
    get getSalesByTech() {
        return this.salesTechData;
    }
    get getSalesByRegion() {
        return this.salesRegionData;
    }
    get getNumberOfMarginByTech() {
        return this.numberOfMarginByTech;
    }
    get getNumberOfTickets() {
        return this.numberOfTickets;
    }
    get getSameTimePreviousYear() {
        return this.sameTimePreviousYear;
    }
    get getcustomerSameTimePreviousYyear() {
        return this.customerSameTimePreviousYyear;
    }
    get getCustomerNumberOfJobsByTicketSize() {
        return this.customerNumberOfJobsByTicketSize;
    }
    get getCustomerListData() {
        return this.customerListData;
    }
    get getNumberOfJobsByTicketSize() {
        return this.numberOfJobsByTicketSize;
    }
    get gethoursTechStraightOvertime() {
        return this.hoursTechStraightOvertimeData;
    }
    get GetBulkAnalyticsRept() {
        return this.dailyRegistrationGraphData;
    }
    get GetTop10PerformerData() {
        return this.top10PerformerData;
    }
    get GetMarketWisePerformerData() {
        return this.marketWisePerformers;
    }
    get GetOrderByTypeReport() {
        return this.orderByTypeGraphData;
    }
    get GetPartnerCustomerList() {
        return this.partnerCustomerList;
    }
    get GetBulkCustomerList() {
        return this.customerbulkreportlist;
    }
    get GetAgentDetails() {
        return this.agentDetails;
    }
    get GetWalletData() {
        return this.walletData;
    }
    get getChartData() {
        return this.chartData;
    }
    get GetRequestDownload() {
        return this.request;
    }
}
